import React, { useState, useEffect } from 'react';
import { Container, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, CircularProgress } from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import ModuleHeader from '../../components/ModuleHeader';
import api from '../../axios';
import { errorMsg } from '../../utils/errorMsg';

export default function MaoCoracaoLista() {
  const [itens, setItens] = useState([]);
  const [membros, setMembros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [dialog, setDialog] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ discipulando_id: '', discipulador_id: '', status: 'ativo', observacoes: '' });

  const carregar = async () => {
    setLoading(true); setErro('');
    try {
      const [a, m] = await Promise.all([api.get('/mao-coracao'), api.get('/secretaria/membros')]);
      setItens(a.data); setMembros(Array.isArray(m.data) ? m.data : []);
    } catch (e) { setErro(errorMsg(e) || 'Erro'); }
    setLoading(false);
  };
  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => { setEditando(null); setForm({ discipulando_id: '', discipulador_id: '', status: 'ativo', observacoes: '' }); setDialog(true); };
  const abrirEditar = (i) => { setEditando(i); setForm({ discipulando_id: i.discipulando_id, discipulador_id: i.discipulador_id || '', status: i.status, observacoes: i.observacoes || '' }); setDialog(true); };
  const salvar = async () => {
    try {
      const payload = { discipulando_id: Number(form.discipulando_id), discipulador_id: form.discipulador_id ? Number(form.discipulador_id) : null, status: form.status, observacoes: form.observacoes };
      if (editando) await api.put(`/mao-coracao/${editando.id}`, payload);
      else await api.post('/mao-coracao', payload);
      setDialog(false); carregar();
    } catch (e) { setErro(errorMsg(e) || 'Erro ao salvar'); }
  };
  const excluir = async (id) => { if (!window.confirm('Excluir?')) return; try { await api.delete(`/mao-coracao/${id}`); carregar(); } catch (e) { setErro(errorMsg(e)); } };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Mão e Coração" title="Jornada Mão e Coração" />
      {erro && <Box sx={{ color: 'error.main', mb: 2 }}>{erro}</Box>}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" startIcon={<Add />} onClick={abrirNovo}>Novo vínculo</Button>
      </Box>
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead><TableRow>{['Discipulando', 'Discipulador', 'Status', 'Ações'].map(h => <TableCell key={h} sx={{ fontWeight: 700 }}>{h}</TableCell>)}</TableRow></TableHead>
            <TableBody>
              {itens.map(i => (
                <TableRow key={i.id} hover>
                  <TableCell><strong>{i.discipulando_nome || i.discipulando_id}</strong></TableCell>
                  <TableCell>{i.discipulador_nome || '-'}</TableCell>
                  <TableCell><Chip size="small" color={i.status === 'ativo' ? 'success' : 'default'} label={i.status} /></TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => abrirEditar(i)}><Edit fontSize="small" /></Button>
                    <Button size="small" color="error" onClick={() => excluir(i.id)}><Delete fontSize="small" /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editando ? 'Editar vínculo' : 'Novo vínculo'}</DialogTitle>
        <DialogContent>
          <TextField fullWidth select label="Discipulando" value={form.discipulando_id} onChange={e => setForm(f => ({ ...f, discipulando_id: e.target.value }))} sx={{ mt: 1, mb: 2 }}>
            {membros.map(m => <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>)}
          </TextField>
          <TextField fullWidth select label="Discipulador" value={form.discipulador_id} onChange={e => setForm(f => ({ ...f, discipulador_id: e.target.value }))} sx={{ mb: 2 }}>
            {membros.map(m => <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>)}
          </TextField>
          <TextField fullWidth select label="Status" value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} sx={{ mb: 2 }}>
            {['ativo', 'pausado', 'concluido'].map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
          <TextField fullWidth label="Observações" value={form.observacoes} onChange={e => setForm(f => ({ ...f, observacoes: e.target.value }))} />
        </DialogContent>
        <DialogActions><Button onClick={() => setDialog(false)}>Cancelar</Button><Button variant="contained" onClick={salvar}>Salvar</Button></DialogActions>
      </Dialog>
    </Container>
  );
}
